export function readStorage(key, fallback = null) {
  try { return JSON.parse(window.localStorage.getItem(key)) ?? fallback; } catch { return fallback; }
}
export function writeStorage(key, value) {
  try { if (value === null) window.localStorage.removeItem(key); else window.localStorage.setItem(key, JSON.stringify(value)); } catch { /* Storage is optional. */ }
}
export function initialSessionId() {
  const query = new URLSearchParams(window.location.search).get('game');
  const saved = readStorage('qb_game_v2')?.id || readStorage('qb_last_game_session')?.gameId;
  const id = query || saved;
  return typeof id === 'string' && /^[a-zA-Z0-9-]{1,100}$/.test(id) ? id : null;
}
